<template>
  <div>
    <a-modal v-model="visible" width="660px" :title="schedulerId ? '编辑定时任务' : '添加定时任务'" ok-text="确认" cancel-text="取消" @ok="submit" @cancel="close">
      <a-form-model ref="modalForm" :model="modalForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="任务名称" prop="name">
          <a-input v-model="modalForm.name" placeholder="任务名称" />
        </a-form-model-item>
        <a-form-model-item label="执行器" prop="handler">
          <a-select v-model="modalForm.handler" placeholder="任务执行器">
            <a-select-option v-for="(task, index) in registeredList" :key="index" :value="task">{{ task }} </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="任务参数" prop="kwargs">
          <a-textarea v-model="modalForm.kwargs" placeholder="任务执行参数" :rows="5" />
        </a-form-model-item>
        <a-form-model-item label="执行方式" prop="method">
          <a-radio-group v-model="modalForm.method" name="radioGroup" @change="methodChange">
            <a-radio value="crontab"> Crontab </a-radio>
            <a-radio value="interval"> 间隔时间 </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="modalForm.method === 'crontab'" label="执行策略" prop="crontab">
          <a-input v-model="modalForm.crontab" placeholder="请输入Cron表达式，以空格分隔" />
        </a-form-model-item>
        <a-form-model-item v-if="modalForm.method === 'interval'" label="执行策略" prop="interval_every">
          <a-input v-model="modalForm.interval_every">
            <a-select slot="addonAfter" v-model="modalForm.interval_period" style="width: 100px">
              <a-select-option v-for="(period, index) in periods" :key="index" :value="period">{{ period }} </a-select-option>
            </a-select>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="备注信息">
          <a-textarea v-model="modalForm.description" :rows="2" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { schedulerCreate, schedulerModify, schedulerRegisteredList } from '@/api/system/scheduler';
export default {
  name: 'UserModal',
  props: {
    schedulerId: {
      type: [Number, String],
      default: null
    },
    isShow: {
      type: Boolean,
      default: false
    },
    schedulerForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      loading: false,
      visible: this.isShow,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      periods: ['seconds', 'minutes', 'hours', 'days', 'months', 'years'],
      registeredList: [],
      modalForm: {
        nickname: null,
        telephone: null,
        email: null
      },
      rules: {
        name: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        handler: [{ required: true, message: '请选择任务执行器', trigger: 'blur' }],
        kwargs: [{ required: true, message: '请输入任务执行参数', trigger: 'blur' }],
        method: [{ required: true, message: '请选择执行方式', trigger: 'blur' }],
        crontab: [{ required: true, message: '请输入Cron表达式', trigger: 'blur' }],
        interval_every: [{ required: true, message: '请输入间隔时间', trigger: 'blur' }]
      }
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        this.getSchedulerRegisteredList();
      }
    },
    schedulerForm() {
      this.modalForm = {
        name: this.schedulerForm.name,
        args: this.schedulerForm.args,
        handler: this.schedulerForm.handler,
        kwargs: this.schedulerForm.kwargs,
        crontab: this.schedulerForm.crontab,
        method: this.schedulerForm.interval_every ? 'interval' : 'crontab',
        description: this.schedulerForm.description,
        interval_every: this.schedulerForm.interval_every,
        interval_period: this.schedulerForm.interval_period
      };
    }
  },
  methods: {
    close() {
      this.loading = false;
      this.visible = false;
      this.$emit('close');
    },
    methodChange() {
      if (this.modalForm.method === 'interval' && !this.modalForm.interval_period) {
        this.modalForm.interval_period = this.periods[0];
      }
    },
    async getSchedulerRegisteredList() {
      const { code, message, data } = await schedulerRegisteredList({});
      if (code === 2000) {
        this.registeredList = data.task_list;
      } else {
        this.$message.warning(message);
      }
    },

    async submitData() {
      this.loading = true;
      if (this.schedulerId) {
        const { code, message } = await schedulerModify({ ...this.modalForm, scheduler_id: this.schedulerId });
        if (code === 2000) {
          this.$message.success('定时任务修改成功');
          this.close();
        } else {
          this.loading = false;
          this.$message.warning(message);
        }
      } else {
        const { code, message } = await schedulerCreate(this.modalForm);
        if (code === 2000) {
          this.$message.success('定时任务添加成功');
          this.close();
        } else {
          this.loading = false;
          this.$message.warning(message);
        }
      }
    },

    async submit() {
      this.$refs.modalForm.validate(valid => {
        if (valid) {
          this.submitData();
        }
      });
    }
  }
};
</script>
